export default __webpack_public_path__ + "static/media/6 yasas.9e7277ac.png";